﻿import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { SearchResult } from '../_models/index';

import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BackendSearchService {

  constructor(public http: HttpClient) {
    if(!localStorage.getItem('auth_token')){
      localStorage.setItem('auth_token', '')
    }
  }

  search(query: string, type: string): Observable<SearchResult>{
    return this.http.get('https://crestdb.org/api/search', {
      observe: 'response',
      headers: new HttpHeaders()
        .set('Accept', 'application/json')
        .set('Authorization', localStorage.getItem('auth_token')),
      params: new HttpParams()
        .set('query', encodeURIComponent(query))
        .set('type', type)
    }).pipe(
      map(item => {
        return new SearchResult({ data: item });
      }));
  }

  searchStructExact(query: string, mode: string, category: string): Observable<SearchResult>{
    return this.http.get('https://crestdb.org/api/search', {
      observe: 'response',
      headers: new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Authorization', localStorage.getItem('auth_token')),
    params: new HttpParams()
      .set('query', encodeURIComponent(query))
      .set('type', 'structure')
      .set('mode', mode)
      .set('category', category)
    }).pipe(
      map(item => {
        return new SearchResult({ data: item });
      }));
  }

  searchSimilarity(query: string, tanimoto: number, category: string): Observable<SearchResult> {

    return this.http.get('https://crestdb.org/api/search', {
      observe: 'response',
      // withCredentials: true,
      headers: new HttpHeaders()
        .set('Accept', 'application/json')
        .set('Authorization', localStorage.getItem('auth_token')),
      params: new HttpParams()
        .set('query', encodeURIComponent(query))
        .set('type', 'structure')
        .set('tanimoto', tanimoto.toString())
        .set('mode', 'similarity')
        .set('category', category)
    }).pipe(
      map(item => {
        return new SearchResult({ data: item });
      }));
  }
}
